import styled from "styled-components";

interface TextProps {
  isValid: boolean;
  isIcon?: boolean;
  disabled?: boolean;
}

const setColor = ({ isValid, disabled }: TextProps) => {
  if (disabled) {
    return "#A3AFD1";
  }

  if (isValid) {
    return "#378531";
  }

  return "#1B2852";
};

export const Text = styled.p<TextProps>`
  color: ${(props): string => setColor(props)};
  width: ${({ isIcon }): string => (isIcon ? "16px" : "auto")};
  font-size: 14px;
  padding-left: 12px;

  font-family: AvertaPE;
  font-style: normal;
  font-weight: normal;

  line-height: 17px;
  letter-spacing: 0.15px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;
